
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.778 15.833h-1.86v-2.375h1.654c.095-.57.293-1.1.57-1.583H7.917V9.5h3.167v1.22c.46-.428.99-.737 1.583-.943V9.5h3.167v.277a4.413 4.413 0 011.583.942V3.96c0-.872-.712-1.584-1.583-1.584H3.167c-.87 0-1.583.712-1.583 1.583v11.875c0 .871.712 1.584 1.583 1.584h7.553a4.412 4.412 0 01-.942-1.584zm2.89-10.291h3.166v2.375h-3.167V5.542zm-4.75 0h3.166v2.375H7.917V5.542zM6.333 15.833H3.167v-2.375h3.167v2.375zm0-3.958H3.167V9.5h3.167v2.375zm0-3.958H3.167V5.542h3.167v2.375z"}}),_c('path',{attrs:{"d":"M17.816 18.073h-3.844V13.18h3.844v4.893zm0-5.592h-3.844a.699.699 0 00-.7.699v4.893a.699.699 0 00.7.698h3.844a.699.699 0 00.699-.698V13.18a.699.699 0 00-.699-.7zm-1.048-1.398h-4.194a.699.699 0 00-.699.699v4.893h.699v-4.893h4.194v-.699z","stroke":"#444","stroke-width":".3"}}),_c('rect',{attrs:{"x":"8","y":"8","width":"13.09","height":"13.09","rx":"6.545","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.281 18.413h-4.15v-5.282h4.15v5.282zm0-6.037h-4.15a.755.755 0 00-.755.755v5.282a.754.754 0 00.755.755h4.15a.754.754 0 00.755-.755v-5.282a.754.754 0 00-.755-.755zm-1.132-1.509h-4.527a.755.755 0 00-.755.755v5.282h.755v-5.282h4.527v-.755z","stroke":"#444","stroke-width":".2"}})])
          )
        }
      }
    